import { replace } from 'connected-react-router';
import { CHANGE_LANGUAGE } from './types';
import { setCookie, getCookie } from '../../utils/helpers';

export const changeLang = (lang, url) => {
  let userPreferences = JSON.parse(getCookie('userPreferences'));
  let tester = RegExp('^(/en/|/fr/)', 'g').test(url);

  if (tester) {
    userPreferences
      ? setCookie(
        'userPreferences',
        JSON.stringify({
          ...JSON.parse(getCookie('userPreferences')),
          lang
        })
      )
      : setCookie('userPreferences', JSON.stringify({ lang }));

    return dispatch => {
      dispatch(replace(url.replace(/\/en\/|\/fr\//g, `/${lang}/`)));
      dispatch({ type: CHANGE_LANGUAGE, lang: lang || 'en' });
    };
  } else {
    userPreferences
      ? setCookie(
        'userPreferences',
        JSON.stringify({
          ...JSON.parse(getCookie('userPreferences')),
          lang: 'en'
        })
      )
      : setCookie('userPreferences', JSON.stringify({ lang: 'en' }));
    return dispatch => {
      dispatch(replace(`/en${url}`));
      dispatch({ type: CHANGE_LANGUAGE, lang: 'en' });
    };
  }
};
